export const filtersList = [
  {
    id: "all",
    label: "All",
    value: "all"
  },
  {
    id: "physicians",
    label: "Physicians",
    value: "physician"
  },
  {
    id: "hospitals",
    label: "Hospitals",
    value: "hospital"
  },
  {
    id: "clinics",
    label: "Clinics",
    value: "clinic",
  },
  {
    id: "ohcp",
    label: "Advanced Medical Professionals",
    value: "other healthcare"
  },
  {
    id: "nfp",
    label: "Non-For-Profits",
    value: "nfp"
  },
  {
    id: "Businesses",
    label: "Businesses",
    value: "Business"
  }
];
